import { render } from "./ByDelegationTab.vue?vue&type=template&id=7ab32266"
import script from "./ByDelegationTab.vue?vue&type=script&lang=ts"
export * from "./ByDelegationTab.vue?vue&type=script&lang=ts"

import "./ByDelegationTab.vue?vue&type=style&index=0&id=7ab32266&lang=scss"
script.render = render

export default script